import React, { useEffect, useState } from 'react';

const EnamDetails = ({ handleSubmit }) => {

  useEffect(() => {
  handleSubmit('I want to raise a complaint for credit card rewards',true)
  }, []);

  return null
};

export default EnamDetails;
